import { environment } from '@environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class IcrDictionaryService {
    // eslint-disable-next-line
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getIcrDictionary(lang) {
        return this.httpClient.get(environment.api.base + 'dictionarys/keywords?language=' + lang);
    }
    addKeywords(data) {
        return this.httpClient.post(environment.api.base +
            'dictionarys/keywords?language=' +
            data.lang +
            '&risk=' +
            data.risk +
            '&bucket=' +
            data.bucket, data.keyword);
    }
    deleteKeyword(id) {
        return this.httpClient.delete(environment.api.base + 'dictionarys/keywords/' + id);
    }
}
IcrDictionaryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function IcrDictionaryService_Factory() { return new IcrDictionaryService(i0.ɵɵinject(i1.HttpClient)); }, token: IcrDictionaryService, providedIn: "root" });
